import { ApiError, ServerErrorEnum } from 'src/api/types'

export const isServerErrorShouldBeHandled = (error?: ApiError | null) => {
  if (error === ServerErrorEnum.EmptyAccountToken) return true

  return false
}
